/// <amd-module name="TFS/CreateProject/Components/ProjectDescriptionTextField" />
import * as React from "react";
import { ProjectParameterConstants } from "TFS/CreateProject/Constants";
import * as CreateProjectResources from "TFS/CreateProject/Resources";
import { ObservableValue } from "VSS/Core/Observable";
import { getId } from "VSS/Core/Util/Object";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { TextField } from "VSSUI/TextField";
import { FormItem } from "VSSUI/FormItem";

export interface IProjectDescriptionTextFieldProps {
    onProjectDescriptionTextFieldKeyDown: (event: React.KeyboardEvent<HTMLInputElement>) => void;
    onChanged: (value: string) => void;
    value: string;
    disabled: boolean;
}

export class ProjectDescriptionTextField extends VssComponent<IProjectDescriptionTextFieldProps, {}> {
    private _projectDescriptionAriaDescriptionId: string;
    private _projectDescriptionText = new ObservableValue<string>("");
    private _projectDescriptionTextFieldId: string;

    constructor(props: IProjectDescriptionTextFieldProps, context: IVssComponentContext) {
        super(props, context);

        this._projectDescriptionTextFieldId = getId("project-description-textfield");
        this._projectDescriptionAriaDescriptionId = getId("project-description-aria-description");
        this._projectDescriptionText.value = this.props.value;
    }

    public render(): JSX.Element {
        return (
            <div className="project-description-container">
                <FormItem label={CreateProjectResources.CreateProjectDescriptionContainerHeader}>
                    <TextField
                        inputClassName="description-textarea-input"
                        key={this._projectDescriptionTextFieldId}
                        ariaDescribedBy={this._projectDescriptionAriaDescriptionId}
                        multiline={true}
                        onKeyDown={this.props.onProjectDescriptionTextFieldKeyDown}
                        autoAdjustHeight={true}
                        onChange={this.onValueChanged}
                        disabled={this.props.disabled}
                        maxLength={ProjectParameterConstants.MaxProjectDescriptionLength}
                        value={this._projectDescriptionText}
                    />
                </FormItem>
                <div className="hidden" id={this._projectDescriptionAriaDescriptionId}>
                    {CreateProjectResources.ProjectDecriptionTextFieldAriaDescription}
                </div>
            </div>
        );
    }

    private onValueChanged = (event: React.ChangeEvent<HTMLInputElement>, newValue: string) => {
        this._projectDescriptionText.value = newValue;

        if (this.props.onChanged) {
            this.props.onChanged(newValue);
        }
    };
}
